export const selectIsAuthenticated = (state) =>
	Boolean(state?.entities?.api_key?.access_token);
